import moment from 'moment'

// 格式化时间戳为 YYYY-MM-DD HH:mm:ss 的moment对象
export function timeTransfer (time) {
  return time ? moment(Date.parse(new Date(time))).format('YYYY-MM-DD HH:mm:ss') : ''
}
export function dateTransfer (time) {
  return time ? moment(Date.parse(new Date(time))).format('YYYY-MM-DD') : ''
}
